import type { GetMeUserResponse } from "@nlc/shared-types";

import { USER_ROLES } from "@nlc/shared-types";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { DashboardPage } from "@/features/dashboard";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/dashboard/")({
  beforeLoad: async ({ context }) => {
    const userData = context.queryClient.getQueryData<GetMeUserResponse>([
      "user",
    ]);
    const role = userData?.user?.roleName;

    if (
      role === USER_ROLES.OWNER ||
      role === USER_ROLES.ADMIN ||
      role === USER_ROLES.COLLABORATOR
    ) {
      throw redirect({ to: "/requests" as string });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Dashboard");

  return <DashboardPage />;
}
